<template>
    <div class="section-banner">
        <div class="container">
            <div class="section-banner__row row">
                <div class="col-7">
                    <div class="section-banner__image">
                        <img :src="`${imgURL}phones2.png`" alt="phones">
                    </div>
                </div>

                <div class="col-5">
                    <div class="section-banner__content">
                        <h1 class="banner-title about-project__h2-title color-white">Fyrsta bílasölu-<br/> appið á
                            Íslandi</h1>
                        <p class="banner-description text color-white">Finndu nýjan bíl á tilteknu verði, af tiltekinni
                            stærð eða gerð og berðu saman kostina sem umboðin bjóða. </p>
                        <div class="banner-counts color-white">
                            <div class="banner-counts__item">
                                <span class="title">10</span>
                                <span class="text">Fjöldi bílaumboða</span>
                            </div>

                            <div class="banner-counts__item">
                                <span class="title">317</span>
                                <span class="text">Mismunandi gerðir</span>
                            </div>

                            <div class="banner-counts__item">
                                <span class="title">1600</span>
                                <span class="text">Fjöldi útfærslur í boði</span>
                            </div>
                        </div>

                        <div class="row banner__images-store">
                            <!--                        <a href="https://apps.apple.com/us/app/b%C3%ADlaskr%C3%A1/id1489190302" target="_blank" class="banner__image-store">-->
                            <!--                            <img :src="`${imgURL}applestore.png`" alt="">-->
                            <!--                        </a>-->

                            <!--                        <a href="https://play.google.com/store/apps/details?id=com.bilaskra.app" target="_blank" class="banner__image-store">-->
                            <!--                            <img :src="`${imgURL}android-app.png`" alt="">-->
                            <!--                        </a>-->
                            <a-blank href="https://apps.apple.com/app/apple-store/id1489190302?pt=120497884&ct=BilaskraApp&mt=8"
                                     class="banner__image-store">
                                <img :src="`${imgURL}applestore.png`" alt="">
                            </a-blank>

                            <a-blank href="https://play.google.com/store/apps/details?id=com.bilaskra.app"
                                     class="banner__image-store">
                                <img :src="`${imgURL}android-app.png`" alt="">
                            </a-blank>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import ABlank from "@/components/ABlank";

    export default {
        components: {
            ABlank
        },
        props: {
            imgURL: {
                type: String,
                default: ''
            }
        }
    }
</script>